import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IPartnerMissedContactsView } from 'clickNgo/models/crud/views'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { IPartnerMissedContacts } from '../models/contacts'

import { mapPartnerMissedContacts } from './mapping/mapPartnerMissedContacts'

export const fetchPartnerMissedContacts = async (
  partnerId: string,
  options?: ICrudFetchOptions
): Promise<IPartnerMissedContacts> => {
  const source = CrudStore.get<IPartnerMissedContactsView>(
    CrudStoreItem.PartnerMissedContacts,
    options?.cacheKey || partnerId
  )

  return source
    .getById({ id: partnerId, force: options?.isForce, keyField: 'PartnerId' })
    .then((data: IPartnerMissedContactsView) => {
      return mapPartnerMissedContacts(data)
    })
    .catch((error) => {
      Logger.error('fetchPartnerMissedContacts error', error)
      return { partnerId, missedRoles: [] }
    })
}
